import { j as o } from "./index58.mjs";
import { Button as s } from "./index8.mjs";
import { Divider as d } from "./index14.mjs";
import { Modal as f } from "./index6.mjs";
const C = (e) => {
  const { loading: n, title: r, icon: l, color: t, content: m, opened: c, onClose: i, onConfirm: a } = e;
  return /* @__PURE__ */ o.jsxs(f, { opened: c, onClose: i, size: "sm", children: [
    /* @__PURE__ */ o.jsxs("h2", { className: `flex items-center gap-2 text-${t}-400`, children: [
      l,
      r
    ] }),
    /* @__PURE__ */ o.jsx(d, {}),
    /* @__PURE__ */ o.jsx("p", { children: m }),
    /* @__PURE__ */ o.jsx(
      s,
      {
        loading: n,
        onClick: a,
        className: "float-right ml-2",
        color: t,
        size: "sm",
        "data-testid": "confirm-button",
        children: "Confirm"
      }
    ),
    /* @__PURE__ */ o.jsx(
      s,
      {
        onClick: i,
        variant: "subtle",
        className: "float-right",
        color: t,
        size: "sm",
        children: "Cancel"
      }
    )
  ] });
};
export {
  C as Confirm
};
